/*
SharedStorageGlobalSubscribeStrategyQiankun

Notes:
    The Qiankun onGlobalStateChange listener can only be started once per app. Like once in the webapp and once in the microservice.

    So the startGlobalSubscribe method below needs to be called once per app...
        which will ensure the separate shared storages in the webapp and microservice are synced
*/

class SharedStorageGlobalSubscribeStrategyQiankun {
    constructor(sharedStorage, qiankunMethodPromise, valueComparer) {
        this.sharedStorage = sharedStorage;
        this.qiankunMethodPromise = qiankunMethodPromise;
        this.valueComparer = valueComparer;
    }

    startGlobalSubscribe = async () => {
        const { onGlobalStateChange, offGlobalStateChange } = await this.qiankunMethodPromise;

        // when the storage changes...
        // set each of the storage keys to their new value
        onGlobalStateChange((value, prevValue) => {
            Object.keys(value).forEach(key => {
                const areValuesEqual = this.valueComparer.isDeepEqual(
                    this._extractFormattedValue(value[key]), 
                    this._extractFormattedValue(prevValue[key])
                );
                if (areValuesEqual === true) return;                

                // set the formatted value (includes _set_by)
                // check the agent set method for documentation
                this.sharedStorage.set(key, value[key]);
            });
        })

        return offGlobalStateChange;
    }

    // check the agent set method for documentation
    _extractFormattedValue = (value) => {
        if (value?._set_by) {
            return value.value;
        }
        return value;
    }
}

export default SharedStorageGlobalSubscribeStrategyQiankun;